module.exports = __webpack_public_path__ + "static/media/ic_comment_disabled.07a00be6.svg";